module.exports = __webpack_public_path__ + "img/bg1.0ac87fd2.png";